"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledPlaceholder = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _NoteForm = _interopRequireDefault(require("../NoteForm"));
var _OnClickOutside = _interopRequireDefault(require("../../../OnClickOutside"));
var _prepareTextWithLinks = _interopRequireDefault(require("../../../../utils/prepareTextWithLinks"));
var _iconsReact = require("../../../../icons-react");
var _excluded = ["hovered", "placeholder", "readOnly", "value"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledTextarea = _NoteForm["default"].StyledTextarea;
var Note = /*#__PURE__*/function (_React$PureComponent) {
  function Note(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Note);
    _this = _callSuper(this, Note, [props]);
    _this.state = {
      isEditing: false
    };
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleSave = _this.handleSave.bind(_this);
    _this.toggleEdit = _this.toggleEdit.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Note, _React$PureComponent);
  return (0, _createClass2["default"])(Note, [{
    key: "handleClose",
    value: function handleClose() {
      var isEditing = this.state.isEditing;
      if (!isEditing) {
        return;
      }
      this.toggleEdit();
    }
  }, {
    key: "handleSave",
    value: function handleSave(_ref) {
      var value = _ref.value;
      var _this$props = this.props,
        id = _this$props.id,
        onEdit = _this$props.onEdit;
      this.toggleEdit();
      onEdit({
        id: id,
        value: value
      });
    }
  }, {
    key: "toggleEdit",
    value: function toggleEdit() {
      var onToggleEdit = this.props.onToggleEdit;
      this.setState(function (prevState) {
        return {
          isEditing: !prevState.isEditing
        };
      });
      onToggleEdit();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        hovered = _this$props2.hovered,
        placeholder = _this$props2.placeholder,
        readOnly = _this$props2.readOnly,
        value = _this$props2.value,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var isEditing = this.state.isEditing;
      delete props.onEdit;
      delete props.onToggleEdit;
      return /*#__PURE__*/_react["default"].createElement(_OnClickOutside["default"], {
        onClickOutside: this.handleClose
      }, /*#__PURE__*/_react["default"].createElement(StyledNote, (0, _extends2["default"])({}, props, {
        isEditing: isEditing
      }), /*#__PURE__*/_react["default"].createElement(StyledNoteWrap, {
        isEditing: isEditing
      }, isEditing ? /*#__PURE__*/_react["default"].createElement(StyledNoteForm, {
        value: value,
        onCancel: this.toggleEdit,
        onSubmit: this.handleSave
      }) : /*#__PURE__*/_react["default"].createElement(StyledNoteText, null, readOnly ? /*#__PURE__*/_react["default"].createElement("span", {
        dangerouslySetInnerHTML: {
          __html: (0, _prepareTextWithLinks["default"])(value)
        }
      }) : /*#__PURE__*/_react["default"].createElement(StyledEditableText, {
        functional: true,
        title: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        onClick: this.toggleEdit
      }, value ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        dangerouslySetInnerHTML: {
          __html: (0, _prepareTextWithLinks["default"])(value)
        }
      }), /*#__PURE__*/_react["default"].createElement(StyledEditIcon, {
        visible: hovered
      })) : /*#__PURE__*/_react["default"].createElement(StyledPlaceholder, null, placeholder))))));
    }
  }]);
}(_react["default"].PureComponent);
Note.propTypes = {
  className: _propTypes["default"].string,
  hovered: _propTypes["default"].bool,
  id: _propTypes["default"].number.isRequired,
  onEdit: _propTypes["default"].func,
  onToggleEdit: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,
  value: _propTypes["default"].string
};
Note.defaultProps = {
  className: '',
  hovered: false,
  onEdit: Function.prototype,
  onToggleEdit: Function.prototype,
  placeholder: null,
  readOnly: false,
  value: ''
};
var StyledNote = _styledComponents["default"].div.withConfig({
  displayName: "Note__StyledNote",
  componentId: "sc-1frhlbe-0"
})(["width:100%;display:flex;", ""], function (_ref2) {
  var isEditing = _ref2.isEditing;
  return isEditing && "\n    z-index: 3;\n    position: relative;\n  ";
});
var StyledPlaceholder = exports.StyledPlaceholder = _styledComponents["default"].span.withConfig({
  displayName: "Note__StyledPlaceholder",
  componentId: "sc-1frhlbe-1"
})([""]);
var StyledEditableText = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Note__StyledEditableText",
  componentId: "sc-1frhlbe-2"
})(["text-align:left;width:calc(100% - 24px);path{stroke:#007aff;}"]);
var StyledEditIcon = (0, _styledComponents["default"])(_iconsReact.Edit).withConfig({
  displayName: "Note__StyledEditIcon",
  componentId: "sc-1frhlbe-3"
})(["width:14px;height:15px;margin-left:5px;margin-bottom:-4px;path{stroke:#919499;}", " :hover{path{stroke:#007aff;}}"], function (_ref3) {
  var visible = _ref3.visible;
  return visible && "\n    opacity: 1;\n  ";
});
var StyledNoteText = _styledComponents["default"].span.withConfig({
  displayName: "Note__StyledNoteText",
  componentId: "sc-1frhlbe-4"
})(["display:block;width:100%;word-wrap:break-word;"]);
var StyledNoteForm = (0, _styledComponents["default"])(_NoteForm["default"]).withConfig({
  displayName: "Note__StyledNoteForm",
  componentId: "sc-1frhlbe-5"
})(["", "{padding:0;border:none;height:auto;min-height:20px;}"], StyledTextarea);
var StyledNoteWrap = _styledComponents["default"].div.withConfig({
  displayName: "Note__StyledNoteWrap",
  componentId: "sc-1frhlbe-6"
})(["width:100%;position:relative;", ""], function (_ref4) {
  var isEditing = _ref4.isEditing;
  return isEditing && "\n    ".concat(StyledNoteText, " { opacity: 0; }\n  ");
});
var _default = exports["default"] = Note;